import {addBreadcrumb, removeBreadcrumb} from 'Core/ducks/breadcrumbs';
import {createBreadcrumb} from 'Core/models/Breadcrumb';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

export function useBreadcrumbs(title: string, path: string) {
  const dispatch = useDispatch();
  const [breadcrumbId, setBreadcrumbId] = useState<O.Option<string>>(O.none);
  useEffect(() => {
    pipe(O.some(removeBreadcrumb), O.ap(breadcrumbId), O.map(dispatch));

    const {
      payload: {id},
    } = dispatch(addBreadcrumb(createBreadcrumb(title, path)));

    setBreadcrumbId(O.some(id));

    return () => {
      dispatch(removeBreadcrumb(id));
    };
  }, [title, path]);
}
